import { useState } from "react"

export const LibraryState = () => {
    const [artcl, setArtcl] = useState({
        list: [],
        view: [],
        suggestion: [],
        related: [],
        isLoad: false
    });

    const [categories, setCategories] = useState(
        { name: 'All', value:'all' }, 
        { name: 'BIR Issuance', value: 1 }, 
        { name: 'CTA Decision', value: 2 }
    )

    const [reaction, setReaction] = useState({
        list:[],
        active:[]
    });

    const [count, setcount] = useState({comment: '', reaction: ''});
    
    // For new publication ↓
    const [ publicationList, setPublicationList ] = useState([])
    const [ publicationView, setPublicationView ] = useState([])
    const [comment, setComment] = useState({
        list:[],
        toggled: false,
        submit_type: 'createComment',
        type:'create-comment',
        id: '',
        value:'',
        loader: false,
        count: 0,
        isReacted: 'default', 
        identifier: '',
        notification_id: null,
        author_id: '',
        reply: {
            id: 0,
            toggled: false,
            data: null,
            type: '',
            value: '',
            showInput: [],
            showReply: [],
            parent_id: 0,
            list: [],
            count: 0,
            notification_id: null,
        },
        menu: {
            toggled: null
        }, 
        alert:{
            toggled: false,
            message: ''
        },
        notification: {
            comment_id: ''
        }
    })


    // For new bulletin ↓
    const [bulletinList, setBulletinList] = useState([])

    return {
        artcl : { data: artcl, set: setArtcl},
        categories : { data: categories, set: setCategories},
        reaction : { data: reaction, set: setReaction},
        count : { data: count, set: setcount},
        
        // For new publication ↓
        
        publicationList : { data: publicationList, set: setPublicationList},
        publicationView : { data: publicationView, set: setPublicationView},
        comment : { data: comment, set: setComment},

        // For new bulletin ↓

        bulletinList : { data: bulletinList, set: setBulletinList }
    }
}